import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import './index.css';
import { useParams, useHistory } from "react-router-dom";
import { parse } from 'date-fns';
import InputMask from 'react-input-mask';
import { format } from 'date-fns-tz';
import api from '../../services/api_adiantamento';
import { mask, unMask } from 'remask'

export default function EncContas() {

    const [encContas, setEncContas] = useState([]);
    const [dtPgto, setDtPgto] = useState('');
    const [numDoc, setNumDoc] = useState('');
    const [valor, setValor] = useState('');
    const [atualiza, setAtualiza] = useState(null);
    const [anexo, setAnexo] = useState(null);
    const [logEmpresa, setLogEmpresa] = useState({});

    let history = useHistory();
    let params = useParams();

    useEffect(() => {
        api.get(`/empresa/find`).then(function (response) {
            if (response.data) {
                setLogEmpresa(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])

    useEffect(() => {
        api.get(`/encconta/adiantamento/${params.adiantamento_id}`).then(function (response) {
            if (response.data) {
                setEncContas(response.data);
                setAtualiza(false);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [params.adiantamento_id, atualiza])

    function handleClose(event) {
        event.preventDefault();
        history.push('/gestaoadiantamento/' + params.adiantamento_id);
    }

    function handleDelete(event) {

        event.preventDefault();
        api.delete(`/encconta/${event.target.id}`).then(function (response) {
            if (response.data) {
                setAtualiza(true);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function rowEncContas(encConta) {
        return (
            <tr className={"table-secondary mouse"} id={encConta.id} key={encConta.id}>
                <td id={encConta.id}>{format(new Date(encConta.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                <td id={encConta.id}>{encConta.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                <td id={encConta.id}>{encConta.num_documento}</td>
                <td id={encConta.id}><input type="submit" value="APAGAR" className="btn btn-danger" id={encConta.id} onClick={handleDelete} /></td>
            </tr>
        );
    }

    function handleAdd(event) {
        event.preventDefault();
        const data = {
            adi_adiantamento_id: params.adiantamento_id,
            num_documento: numDoc,
            empresa_id: 4,
            data: parse(dtPgto, 'dd/MM/yyyy', new Date()),
            valor: valor.replace(/[^0-9,]*/g, '').replace(',', '.'),
            status: 0,
            anexo: anexo,
        };

        api.post(`/encconta`, data).then(function (response) {
            //sucess
            setAtualiza(true);
            setValor('');
            setNumDoc('');
            setDtPgto('');
            setAnexo(null);
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function handleMask(event) {
        event.preventDefault();
        const originalValue = unMask(event.target.value);
        const maskedValue = mask(originalValue, [
            ",9", ",99", "9,99", "99,99", "999,99", "9.999,99", "99.999,99", "999.999,99", "9.999.999,99", "99.999.999,99"
        ]);
        setValor(maskedValue);
    }

    function handleUpload({ target: { files } }) {
        let anexo = new FormData();
        anexo.append('file', files[0]);
       
        api.post('/adiantamento/posts', anexo).then(function (response) {
            if (response.data) {
                setAnexo(response.data.filename); 
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    return (
        <div className="container-lg-lg">
            <Header title="ENCONTRAMENTO DE CONTAS" />
            <div className="col-md-12 mb-2 border row">
                <div className="col-md-2 mb-2">
                    <label>Data:</label>
                    <InputMask mask="99/99/9999" id="data" value={dtPgto} className="form-control" onChange={(e) => setDtPgto(e.target.value)} />
                </div>
                <div className="col-md-2 mb-2">
                    <label>Num documento:</label>
                    <input type="text" id="num_documento" value={numDoc} className="form-control" onChange={(e) => setNumDoc(e.target.value)}></input>
                </div>
                <div className="col-md-2 mb-2">
                    <label>Valor:</label>
                    <input type="text" id="vallor" value={valor} className="form-control" onChange={handleMask}></input>
                </div>
                <div className="col-md-6 mb-2 descer">
                    <input type="file" className="btn btn-info" onChange={handleUpload} />
                </div>
            </div>
            <div className="col-md-12 mb-2">
                <input type="submit" value="ADICIONAR" className="btn btn-success" onClick={handleAdd} />
            </div>
            <div className="col-md-12 mb-2 border">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Data</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Documento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            encContas.map(encConta => {
                                return (
                                    rowEncContas(encConta)
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <div className=" row col-md-12">
                <div className="col-md-3">

                </div>
                <div className="col-md-3">

                </div>
                <div className="col-md-3">

                </div>
                <div className="col-md-3">
                    <input type="submit" value="FECHAR" className="btn btn-dark" onClick={handleClose} />
                </div>
            </div>
        </div>
    )
}